import { render, staticRenderFns } from "./ConsentBanner.vue?vue&type=template&id=6d989f7a&"
import script from "./ConsentBanner.vue?vue&type=script&lang=js&"
export * from "./ConsentBanner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports